<div class="container">
  <div class="row top-padding">
    <div>
      <img id="pcwLogo" src="assets/images/pcw_logo.png" />
    </div>
    <h3>
      智保康 <br />
      管理教育中心
    </h3>
  </div>
</div>
<div style="text-align: left;">
  <a routerLink="../">返回</a>
</div>
<hr />
<h3>課程大綱</h3>
<div class="container">
  <div class="row">
    <div class="col-md-6">
      <div class="homeCard" [routerLink]="['/training', 'nursing']">
        <h3 class="title">輕鬆護老法課程</h3>
      </div>

      <div class="homeCard" [routerLink]="['/training', 'drugManagement']">
        <h3 class="title">社署藥物管理秘笈</h3>
      </div>

      <div class="homeCard" [routerLink]="['/training', 'drugInfo']">
        <h3 class="title">社署藥物必讀</h3>
      </div>

      <div class="homeCard" routerLink="./training-record">
        <h3 class="title">培訓記錄 <i class="fas fa-user-graduate"> </i></h3>
      </div>

      <hr />

      <div class="homeCard" routerLink="./doc">
        <h3 class="title">學校政策</h3>
      </div>
    </div>
    <div class="col-md-6">
      <img
        src="https://firebasestorage.googleapis.com/v0/b/se-ngo.appspot.com/o/images%2Fclassroom.png?alt=media&token=67cfb14c-b82b-42d3-a2a5-c1014c84edfd"
        alt="classroom"
        class="classroomImage rounded"
      />
    </div>
  </div>
</div>
